import React from 'react';
import AuthContent from './layout/AuthContent';
import RecoverForm from './auth/RecoverForm';

const Recover = () => {
    return (
        <AuthContent
            component={RecoverForm}
        />
    );
};

export default Recover;